import { changeDate, headerDateFormatLastLogin } from "helpers/date";
import { getAppleDeviceName } from "helpers/appleDeviceModels";
import i18n from "i18n";

export const FIRST_REPORTING_VERSION = "1.7.0";

// Shown when the user has mobile logins but the app predates version reporting
const olderThanLabel = () =>
	i18n.t("label.olderThanVersion", { version: FIRST_REPORTING_VERSION });

export const formatMobileVersion = (row) => {
	if (row?.lastMobileAppVersion) {
		const seen = row.lastMobileSeen
			? ` · ${changeDate(row.lastMobileSeen)}`
			: "";
		return `${row.lastMobileAppVersion} (${row.lastMobileAppBuild})${seen}`;
	}
	return row?.hasMobileLogin ? olderThanLabel() : "—";
};

export const getLastMobileConnectionLabel = (row) => {
	if (row?.lastMobileAppVersion) {
		const seen = row.lastMobileSeen
			? ` · ${headerDateFormatLastLogin(row.lastMobileSeen)}`
			: "";
		return `${row.lastMobileAppVersion} (${row.lastMobileAppBuild})${seen}`;
	}
	if (row?.hasMobileLogin) {
		return olderThanLabel();
	}
	return null;
};

export const getDeviceLabel = (row) => {
	const deviceName = getAppleDeviceName(row?.lastMobileDeviceModel);
	const osVersion = row?.lastMobileOSVersion;
	if (deviceName && osVersion) {
		return `${deviceName} · ${osVersion}`;
	}
	return deviceName || osVersion || null;
};
